<div class="p-3">
    <div class="flex justify-content-center my-2">
        <label for="dropdownSelect" style="margin: 0.6%;"><span class="fontStyle">MDM Topic Selection : </span></label>
        <p-dropdown id="dropdownSelect" placeholder="Select an option" class="senderDropDown"
                    [options]="dropdownOptions" filter="true" optionLabel="label" optionValue="value" filterBy="label"
                    [(ngModel)]="selectedOption" (onChange)="onDropdownChange($event)" [scrollHeight]="'400px'">
        </p-dropdown>
    </div>

    <ng-container *ngIf="selectedOption === 'Business Areas'">
        <app-crud-table [masterLists]="businessAreas" [tableCols]="baCols" [title]="baTitle"
            [masterListType]="baType"></app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Labs'">
        <app-crud-table [masterLists]="labs" [tableCols]="labCols" [title]="labTitle" [baOptions]="baOptions"
                [masterListType]="labType" [countries]="countries"></app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Machine Types'">
        <app-crud-table [masterLists]="machineTypes" [tableCols]="machineTypesCols" [title]="machineTypesTitle"
        [checkSelectedLab]="selectedLab" [masterListType]="machineTypeList" [labOptions]="labOptions"></app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Machines'">
        <app-crud-table [masterLists]="machines" [tableCols]="machineCols"
        [machineTypesOptions]="machineTypesOptions" [title]="machineTitle" [labOptions]="labOptions"
        [checkSelectedLab]="selectedLab" [masterListType]="machineType"></app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Printers'">
        <app-crud-table [masterLists]="printers" [tableCols]="printerCols" [title]="printerTitle"
                [labOptions]="labOptions" [masterListType]="printerType"></app-crud-table>
    </ng-container>
    
    <ng-container *ngIf="selectedOption === 'Process Step'">
        <app-mdm-process-step [masterLists]="states" [tableCols]="statusCols" [title]="processStepTitle"
                [labOptions]="labOptions" [machineTypesOptions]="machineTypesOptions" [printerOptions]="printerOptions"
                [processStepOptions]="processStepOptions"></app-mdm-process-step>
    </ng-container>
    
    <ng-container *ngIf="selectedOption === 'Sequencer Configurations'">
        <app-crud-table [masterLists]="seqConfigs" [tableCols]="seqConfigCols" [title]="seqConfigTitle"
                [labOptions]="labOptions" [masterListType]="seqConfigType"></app-crud-table>
    </ng-container>
    
    <ng-container *ngIf="selectedOption === 'Products'">
        <app-crud-table [masterLists]="products" [tableCols]="productCols" [sitConfigOptions]="sitConfigOptions"
        [title]="productTitle" [labOptions]="labOptions" [masterListType]="productType"> </app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Chemicals'">
        <app-crud-table [masterLists]="chemicals" [tableCols]="chemicalCols" [title]="chemicalTitle"
                [hazardousTypeOptions]="hazardousTypeOptions" [masterListType]="chemicalType"></app-crud-table>
    </ng-container>
    
    <ng-container *ngIf="selectedOption === 'Health'">
        <p-table [columns]="healthCols" [value]="health" [loading]="loading">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th scope="col" *ngFor="let col of columns">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns" [ngClass]="setColor(rowData[col.field])">
                        {{rowData[col.field]}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Access Logs'">
        <p-table [columns]="accessLogsCols" [value]="accessLog" [loading]="loading">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th scope="col" *ngFor="let col of columns">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData">
                    <ng-container *ngFor="let col of columns" [ngClass]="setColor(rowData[col.field])">
                        <td *ngIf="col.field == 'puid'">
                            {{rowData[col.field]}}
                        </td>
                        <td *ngIf="col.field == 'loginTime' || col.field == 'logoutTime'">
                            {{rowData[col.field] | date: 'dd.MM.yyyy HH:mm a'}}
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td class="nologs" colspan="3">
                        No logs found
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'LibTypes'">
        <app-mdm-library-configuration [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [tableCols]="libConfigCols"
        [masterLists]="libConfigFile" [assayTypeOptions]="assayTypeOptions" [processOptions]="processOptions"
        [loading]="loading"></app-mdm-library-configuration>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Echo Configurations'">
        <app-crud-table [masterLists]="echoConfigs" [tableCols]="echoConfigCols" [title]="echoConfigTitle"
                [labOptions]="labOptions" [masterListType]="echoConfigType"
                [reactionOptionValues]="reactionOptionValues"></app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Sales Item Types'">
        <app-crud-table [masterLists]="sitConfigs" [tableCols]="sitConfigCols" [title]="sitConfigTitle"
        [labOptions]="labOptions" [bmsProductNames]="bmsProductNames" [masterListType]="sitConfigType"
        [maxRedoValues]="maxRedoValues">
    </app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Standard Primers'">
        <app-standard-primer [masterLists]="standardPrimers" [tableCols]="standardPrimerCols"
        [title]="standardPrimerTitle"></app-standard-primer>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Barcode Templates'">
        <app-barcode-template [masterLists]="templates" [tableCols]="templateCols" [title]="templateTitle"
        [labOptions]="labOptions"></app-barcode-template>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Senders'">
        <app-senders-template [masterLists]="senders" [tableCols]="senderCols" [title]="senderTitle"
        [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [loading]="loading"></app-senders-template>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Kits'">
        <app-kits-template [masterLists]="kits" [tableCols]="kitCols" [title]="kitsTitle"
        [detailCols]="kitDetailCols" [checkSelectedLab]="selectedLab" [labOptions]="labOptions"></app-kits-template>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Problem Category'">
        <app-problem-category-template [masterLists]="problemCategories" [checkSelectedLab]="selectedLab"
        [tableCols]="problemCategoriesCols" [title]="problemCategoryTitle">
    </app-problem-category-template>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'QC Problem'">
        <app-problem [masterLists]="problem" [checkSelectedLab]="selectedLab" [tableCols]="problemCols"
                [title]="problemTitle"></app-problem>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Result-Process'">
        <app-mdm-result-process [masterLists]="resultProcess" [checkSelectedLab]="selectedLab"
        [tableCols]="resultProcessCols" [title]="resultProcessTitle"></app-mdm-result-process>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Result Logic'">
        <app-result-engine-config [masterLists]="resultConfigList" [checkSelectedLab]="selectedLab"
                [tableCols]="resultEngineConfigCols" [title]="resultEngineConfigTitle">
            </app-result-engine-config>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Machine Manufacturer'">
        <app-manufacturer-config [tableCols]="manufacturerConfigCols" [masterLists]="manufacturersList"
        [title]="manufacturerConfigTitle" [selectedLab]="selectedLab"></app-manufacturer-config>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Sender External Configurations'">
        <app-exteral-sender-login-template [masterLists]="externalSenderLogins" [tableCols]="externalSenderLoginCols" [title]="externalSenderLoginTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [loading]="loading"></app-exteral-sender-login-template>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Tag System'">
        <app-mdm-tag-system  [masterLists]="tagSystem" [tableCols]="tagSystemCols" [title]="tagSystemTitle"
        [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [tagSystems]="tagSystems" [loading]="loading"></app-mdm-tag-system>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Tag Plates'">
        <app-tags [masterLists]="tags" [tableCols]="tagCols" [title]="tagsTitle"
        [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [tagPlates]="tagPlates" [loading]="loading"></app-tags>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Work Flow'">
        <app-mdm-workflow [masterLists]="workFlow" [tableCols]="workFlowCols" 
            [title]="workFlowTitle" [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [loading]="loading"> </app-mdm-workflow>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'SNP Profile'">
        <app-mdm-snp-profile [masterLists]="snpProfile" [tableCols]="snpProfileCols" 
        [title]="snpProfileTitle" [checkSelectedLab]="selectedLab" [labOptions]="labOptions"> </app-mdm-snp-profile>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Flow Cells'">
        <app-mdm-flowcell [masterLists]="flowCell" [tableCols]="flowCellCols" 
        [title]="flowCellTitle" [checkSelectedLab]="selectedLab" [labOptions]="labOptions"> </app-mdm-flowcell>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Analysis'">
        <app-mdm-analysis [masterLists]="analysis" [tableCols]="analysisCols" 
            [title]="analysisTitle" [checkSelectedLab]="selectedLab" [labOptions]="labOptions"> </app-mdm-analysis>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Process'">
        <app-mdm-process [masterLists]="process" [tableCols]="processCols"  [title]="processTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions"> </app-mdm-process>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Process Type'">
        <app-mdm-processtype [masterLists]="processType" [tableCols]="processTypeCols" [title]="processTypeTitle"
        [checkSelectedLab]="selectedLab" [labOptions]="labOptions"> </app-mdm-processtype>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Station'">
        <app-mdm-station [masterLists]="station" [tableCols]="stationCols" [title]="stationTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions"> </app-mdm-station>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Inbound File Processing'">
        <app-mdm-inbound-file-processing [masterLists]="inBoundFile" [tableCols]="inBoundFileCols" [title]="inBoundFileTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [loading]="loading"> </app-mdm-inbound-file-processing>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Workfiles'">
        <app-mdm-workfiles-config [masterLists]="workFiles" [tableCols]="workFilesCols" [title]="workFilesTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [loading]="loading"> </app-mdm-workfiles-config>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Step Category'">
        <app-mdm-step-category [masterLists]="stepCategories" [tableCols]="stepCategoryCols" [title]="stepCategoryTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [loading]="loading"> </app-mdm-step-category>
    </ng-container>
</div>